<template>
<div style="margin: 0 30px;padding-bottom: 20px">
  <el-table size="small" :data="tableData" border highlight-current-row ref="singleTable">
    <el-table-column
      type="index"
      label="编号"
      width="70"
      align="center">
    </el-table-column>
    <el-table-column
      prop=""
      label="培训名称"
      min-width="70"
      align="center">
    </el-table-column>
    <el-table-column
      prop=""
      label="培训机构"
      min-width="80"
      align="center">
    </el-table-column>
    <el-table-column
      prop=""
      label="培训主题"
      min-width="70"
      align="center">
    </el-table-column>
    <el-table-column
      prop=""
      label="培训地点"
      min-width="100"
      align="center">
    </el-table-column>
    <el-table-column
      prop=""
      label="主讲"
      min-width="80"
      align="center">
    </el-table-column>
    <el-table-column
      prop=""
      label="培训时间"
      min-width="90"
      align="center">
    </el-table-column>
  </el-table>
</div>
</template>

<script>
export default {
  name: 'recordTable',
  model: {
    prop: 'recordShow',
    event: 'change'
  },
  props: {
    staffRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/recordTable.vue